import template from './pagination2.html';
import controller from './pagination2.controller';

/**
 * A new implementation for pagination without using RxJS
 * and will be intended to be more generic.
 */
let pagination2Component = {
  bindings: {
    maxPageCount: '<',
    limitPerPage: '<',
    total: '<',
    onPageClicked: '&'
  },
  template,
  controller
};

export default pagination2Component;



// WEBPACK FOOTER //
// ./client/app/shared/ui/pagination2/pagination2.component.js